import type { UserRole } from '@core/types/api';

export type { UserRole };

/**
 * Mirrors the backend RoleHierarchyConfig: OWNER > ADMIN > DISPATCHER > VIEWER.
 *
 * Duplicated deliberately -- the frontend needs it to decide what to render, and
 * shipping the hierarchy as data from the API would mean an extra round-trip before the
 * first paint. It is a small, stable list; the tests assert both ends agree.
 */
const RANK = {
  VIEWER: 0,
  DISPATCHER: 1,
  ADMIN: 2,
  OWNER: 3,
} as const satisfies Record<UserRole, number>;

export const ROLES = Object.keys(RANK) as UserRole[];

/** True when `role` is at least as privileged as `required`. */
export function roleSatisfies(role: UserRole | undefined, required: UserRole): boolean {
  if (!role) return false;
  return RANK[role] >= RANK[required];
}

/**
 * The role LABELS live in the message catalogue, at `t.role`.
 *
 * <p>They were here as a constant, which made them English on the members table, the
 * invitation list, the navigation footer and the forbidden page all at once. The enum is
 * the contract and stays here; the words are language and belong with the other words.
 */
